import React, { useEffect, useState } from 'react';
import { GECKO_CONSTS, GeckoCardTable } from 'ui';
import GeckoRequest from 'services/gecko-request';
import GeckoLocation from 'services/gecko-location';
import { renderError } from 'services/gecko-error';
import Loader from 'components/Loader';

function Accounts() {
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    GeckoRequest.get('/admin/accounts')
      .then(setAccounts)
      .catch(renderError)
      .finally(() => setLoading(false));
  }, []);

  const columns = [
    {
      key: 'id',
      name: 'ID',
    },
    {
      key: 'name',
      name: 'Name',
    },
    {
      key: 'features',
      name: 'features',
      render: (features = {}) => {
        return Object.keys(features || {})
          .map((key) => {
            const value = features[key];
            return [key, value];
          })
          .filter(([_key, value]) => value === true)
          .map(([key]) => key)
          .join(', ');
      },
    },
    {
      key: 'createdAt',
      name: 'Created At',
      type: GECKO_CONSTS.TABLE_CELL_TYPE_DATE,
    },
  ];

  return (
    <Loader isLoading={loading}>
      <div className="Accounts">
        <GeckoCardTable
          name="Accounts"
          cols={columns}
          rows={accounts}
          rowHandler={(account) => GeckoLocation.goTo(`/admin/${account.id}`)}
        />
      </div>
    </Loader>
  );
}

export default Accounts;
